import { useApi } from '../composables'
import http from '../composables/src/useHttp'

/**
 * Fetch all accessible Jira projects
 */
export const fetchJiraProjects = () => {
  return useApi(http.get('/jira/projects'))
}

/**
 * Fetch statuses for a specific Jira project
 * @param projectId - The Jira project ID (e.g., "10464")
 */
export const fetchJiraProjectStatuses = (projectId: string) => {
  return useApi(http.get(`/jira/projects/${projectId}/statuses`))
}

/**
 * Fetch priorities for a specific Jira project
 * Note: Priorities are global in Jira, but this endpoint is project-specific for consistency
 * @param projectId - The Jira project ID (e.g., "10464")
 */
export const fetchJiraProjectPriorities = (projectId: string) => {
  return useApi(http.get(`/jira/projects/${projectId}/priorities`))
}
